// @flow
import BrowserDetector from 'app/common/lib/BrowserDetector';
import { inOpenModalExperience } from 'app/common/react/components/growth/unauth/open/hybrid/hybridExperimentUtils';
import { isInLoginSignupModalCooldown } from 'app/common/react/components/growth/unauth/open/hybrid/closeupBannerUtils';
import { SignupSource } from 'app/common/react/components/growth/unauth/signup/constants';
import {
  HybridTiers,
  type HybridTierType,
} from 'app/common/react/components/growth/unauth/open/hybrid/hybridConstants';
import {
  MODAL_TYPE,
  BANNER_TYPE,
  type BannerPresentation,
} from 'app/common/react/components/growth/unauth/open/UnauthHybridBanner';

export default function getBannerPresentation(
  marketTier: HybridTierType,
  scrollSessionCount: number,
  dismissed: boolean,
): BannerPresentation {
  // Temp fix for BUG-92861, disable full screen modal on Safari
  const isSafari = BrowserDetector.isSafari();
  if (inOpenModalExperience() || isSafari) {
    return {
      bannerSize: BANNER_TYPE.QUARTER_SCREEN_BANNER,
    };
  }
  switch (marketTier) {
    case HybridTiers.tier1:
      if (scrollSessionCount < 3) {
        return {
          bannerSize: BANNER_TYPE.QUARTER_SCREEN_BANNER,
        };
      } else if (scrollSessionCount === 3 && !dismissed && !isInLoginSignupModalCooldown()) {
        return {
          bannerSize: BANNER_TYPE.FULL_SCREEN_BANNER,
          modalType: MODAL_TYPE.DISMISSIBLE,
          signupSource: SignupSource.login,
        };
      } else if (scrollSessionCount >= 3) {
        return {
          bannerSize: BANNER_TYPE.QUARTER_SCREEN_BANNER,
        };
      } else {
        return {
          bannerSize: BANNER_TYPE.NO_BANNER,
        };
      }
    case HybridTiers.tier2:
      if (scrollSessionCount <= 3) {
        return {
          bannerSize: BANNER_TYPE.QUARTER_SCREEN_BANNER,
        };
      } else if (scrollSessionCount > 3) {
        return {
          bannerSize: BANNER_TYPE.FULL_SCREEN_BANNER,
          modalType: MODAL_TYPE.DEFAULT,
        };
      } else {
        return {
          bannerSize: BANNER_TYPE.NO_BANNER,
        };
      }
    case HybridTiers.tier3:
      if (scrollSessionCount <= 2) {
        return {
          bannerSize: BANNER_TYPE.QUARTER_SCREEN_BANNER,
        };
      } else if (scrollSessionCount > 2) {
        return {
          bannerSize: BANNER_TYPE.FULL_SCREEN_BANNER,
          modalType: MODAL_TYPE.DEFAULT,
        };
      } else {
        return {
          bannerSize: BANNER_TYPE.NO_BANNER,
        };
      }
    default:
      return {};
  }
}
